import { createContext } from 'react';

export type Prefs = { [id: string]: string };

export type PreferencesContextData = {
    prefs: Prefs;
    setPrefs: (key: string, value: string) => void;
    removePrefs: (key: string) => void;
};

export const PreferencesContext = createContext<
    PreferencesContextData | undefined
>(undefined);
